import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tabletsRegistrations: [],
  loading: false,
};

const tabletRegistrationSlice = createSlice({
  name: "tabletRegistration",
  initialState,
  reducers: {
    loading(state) {
      state.loading = true;
    },
    loadingDone(state) {
      state.loading = false;
    },
    setTabletsRegistrations(state, action) {
      state.tabletsRegistrations = action.payload;
    },
  },
});

export const { loading, loadingDone, setTabletsRegistrations } =
  tabletRegistrationSlice.actions;

export default tabletRegistrationSlice.reducer;
